/* ligawspinaczkowa.pl/ */

export const ROUTES = {
  CONTACT: '/contact',
  HOME: '/',
  MATCHES: '/matches',
  LIVE: '/:leagueId/matches/:matchId',
  TEAMS: '/teams',
  LEAGUE: '/league',
  TV_MATCHES: '',
  TV: '/tv/:leagueId/:matchId/:wallId',
  LEAGUE_MATCHES: '/tv/:leagueId',
};
